import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function editInvoice(
  invoiceNo: string,
  arg: InvoiceEditableData | { appointment_status: string },
  onBehalfOf?: string,
) {
  const res = await fetchOrchidAPI(
    `/api/invoicing/entry/${invoiceNo}${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
    {
      method: "PUT",
      body: JSON.stringify(arg),
    },
  );
  if (!res.ok) {
    throw new Error(
      `failed to edit invoice: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
